<template>
  <div class="filter">{{ $t('Наименование клиента') }}<v-text-field
        v-model="tokenName"
        :placeholder="$t('Поиск по наименованию клиента API')"
        single-line
        hide-details
        variant="solo"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const { searchParams } = defineProps({
  searchParams: {
    type: Object,
    required: true,
  },
});

const tokenName = computed({
  get: () => searchParams['token.name'] ?? null,
  set: (newValue) => {
    if (newValue) {
      searchParams['token.name'] = newValue;

      return;
    }
    delete searchParams['token.name'];
  },
});
</script>

<style scoped>
.filter {
  max-width: 253px;
  min-width: 132px;
}
</style>
